import {
  Component,
  OnInit,
  Inject,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AllShipNamesService } from 'src/app/Services/all-ship-names.service';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { UserData } from 'src/app/Models/employee-and-user-data';

type shipInfo = {
  FacilityId: number;
  Code: string;
  Number: string;
  Name: string;
  Type: string;
  Enabled: number;
};

@Component({
  selector: 'app-ship-select',
  templateUrl: './ship-select.component.html',
  styleUrls: ['./ship-select.component.css'],
  providers: [AllShipNamesService],
})
export class ShipSelectComponent {
  OBPortalSvcURL = '';
  busSvcURL = '';

  message = 'Select a Ship';

  userdata?: UserData;

  allshipnamesdata: any;
  allshipnames: shipInfo[] = [];

  click: any;

  constructor(
    private router: Router,
    private appConfigService: AppConfigService,
    private AllShipNamesService: AllShipNamesService
  ) {}

  ngOnInit(): void {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.busSvcURL = this.appConfigService.busSvcURL;
    this.GetAllShipNames();
  }

  GetAllShipNames() {
    this.allshipnamesdata =
      this.AllShipNamesService.GetAllShipNames().subscribe((allshipnamesdata) =>
        this.setAllShipNames(allshipnamesdata)
      );
  }
  setAllShipNames(resdata: any) {
    this.allshipnamesdata = resdata;
    if (this.allshipnamesdata.GetAllShipNames.Result.Status == 'A') {
      this.allshipnames = this.allshipnamesdata.GetAllShipNames.FacilityList;
    }
  }
}
